import { render, staticRenderFns } from "./UtilityDetailComponent.vue?vue&type=template&id=64886f56&scoped=true&"
import script from "./UtilityDetailComponent.vue?vue&type=script&lang=js&"
export * from "./UtilityDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64886f56",
  null
  
)

export default component.exports